import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "formatted-date-wrapper" }

import { ref, computed, watch, onMounted } from "vue";
import { useAuctionStore } from "@/stores/AuctionStore";
import moment from 'moment-timezone';
import 'moment/locale/en-gb';
import { getShortTimezoneName, getLongTimezoneName } from "@/utils/timezones";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormattedDate',
  props: {
  utcDate: String,
  momentJsFormat: {
    type: String,
    default: 'MMMM D, YYYY'
  },
  prefix: {
    type: String,
    default: ''
  },
},
  setup(__props) {

const props = __props;

const auctionStore = useAuctionStore();
const formattedDate = ref('');
const formattedTimezoneShort = ref('');
const formattedTimezoneLong = ref('');
const localTimezone = ref(auctionStore.localTimezone);
const auctionsTimezone = ref(auctionStore.auctionsTimezone);

const isLocalTimezone = computed(() => auctionStore.user?.is_local_timezone ?? false);

const updateDate = () => {
  const utcDate = moment.utc(props.utcDate);
  let format = props.momentJsFormat;

  const tz = isLocalTimezone.value
      ? localTimezone.value
      : auctionsTimezone.value;

  const localDate = utcDate.tz(tz);

  // Timezone short
  if (props.momentJsFormat.slice(-1) === 'z') {
    formattedTimezoneShort.value = getShortTimezoneName(tz, localDate.format('z'));
    format = props.momentJsFormat.slice(0, -1).trim();
  }

  // Timezone long
  formattedTimezoneLong.value = getLongTimezoneName(tz);

  if (format) {
    formattedDate.value = localDate.format(format).replace('___', '\u00A0\u00A0\u00A0');
  }
};

watch(isLocalTimezone, () => {
  updateDate();
});

onMounted(() => {
  updateDate();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.prefix) + " " + _toDisplayString(formattedDate.value), 1))
}
}

})